'use strict';

var isAnimationControls = require('../../animation/utils/is-animation-controls.cjs');
var isVariantLabel = require('./is-variant-label.cjs');
var variantProps = require('./variant-props.cjs');

function isControllingVariants(props) {
    return (isAnimationControls.isAnimationControls(props.animate) ||
        variantProps.variantProps.some((name) => isVariantLabel.isVariantLabel(props[name])));
}
function isVariantNode(props) {
    return Boolean(isControllingVariants(props) || props.variants);
}

exports.isControllingVariants = isControllingVariants;
exports.isVariantNode = isVariantNode;
//# sourceMappingURL=is-controlling-variants.cjs.map
